<template>
  <div class="content-box">
    <div class="row" style="display:flex;justify-content: space-between; margin-bottom: 10px;">
      <div class="columns medium-6 small-12">
        <div class="search-wrap">
          <fluent-icon icon="search" class="search-icon" />
          <input
            type="text"
            :placeholder="$t('CAMPAIGN.EMAIL_TEMPLATE.SEARCH_INPUT_PLACEHOLDER')"
            class="contact-search"
            :value="searchQuery"
            @keyup.enter="onSearchSubmit"
            @input="onInputSearch"
          />
          <woot-button
            :is-loading="false"
            class="clear"
            :class-names="this.searchQuery !== '' ? 'show' : ''"
            @click="onSearchSubmit"
          >{{ $t('CAMPAIGN.EMAIL_TEMPLATE.SEARCH_BUTTON_TEXT') }}</woot-button>
        </div>
      </div>
      <div class="columns medium-6 small-12" style="justify-content: end; display: flex;">
        <router-link :to="{ name: 'email_template_add' }">
          <woot-button>{{ $t('CAMPAIGN.EMAIL_TEMPLATE.ADD_BUTTON_TEXT') }}</woot-button>
        </router-link>
      </div>
    </div>
    <div class="row" style="margin-bottom: 20px;">
      <woot-tabs :index="activeCategoryTab" @change="onTabChange">
        <woot-tabs-item
          v-for="(item, index) in categories"
          :key="index"
          :name="item"
          :show-badge="false"
        />
      </woot-tabs>
    </div>
    <div class="row" style="justify-content: space-between;">
      <spinner class="margin:auto" v-if="isFetchinigEmailTemplate" size="large" />
      <empty-state
        v-if="emailTemplates.length === 0"
        :title="$t('CAMPAIGN.EMAIL_TEMPLATES.INBOXES_NOT_FOUND')"
      />
      <div
        class="medium-5 small-12 columns"
        style="margin-bottom: 20px;"
        v-show="!isFetchinigEmailTemplate && emailTemplates.length > 0"
        v-for="template in emailTemplates"
        :key="template.id"
      >
        <div class="card">
          <div class="row" style="display: flex; align-items: center; margin-bottom: 10px;">
            <div class="medium-8">
              <span class="fs-small">{{ template.name }}</span>
            </div>
            <div class="medium-4" style="justify-content: end; display: flex;">
              <div class="button-wrapper">
                <router-link
                  :to="`/app/accounts/${accountId}/campaigns/email_templates/edit/${template.id}`"
                >
                  <woot-button
                    v-tooltip.top="$t('CAMPAIGN.EMAIL_TEMPLATE.EDIT_BUTTON_TEXT')"
                    variant="smooth"
                    size="small"
                    color-scheme="secondary"
                    class-names="grey-btn"
                    icon="edit"
                  ></woot-button>
                </router-link>
                <woot-button
                  v-tooltip.top="$t('CAMPAIGN.EMAIL_TEMPLATE.DELETE_BUTTON_TEXT')"
                  variant="smooth"
                  color-scheme="alert"
                  size="small"
                  icon="dismiss-circle"
                  class-names="grey-btn"
                  @click="openDeletePopup(template.id)"
                ></woot-button>
              </div>
            </div>
          </div>
          <div style="max-height: 200px; overflow-y: scroll;" v-html="template.templateBody.html"></div>
          <!-- <div class="medium-12 columns" style="margin-top: 10px;">
						<input :id="`contact-${index}`" type="radio" name="selcectedTemplate" value="contact" />
						<label :for="`contact-${index}`">{{
							$t('CAMPAIGN.EMAIL_TEMPLATE.SELECTED_TEMPLATE.TEXT')
						}}</label>
          </div>-->
        </div>
      </div>
    </div>
    <woot-delete-modal
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('LABEL_MGMT.DELETE.CONFIRM.TITLE')"
      :message="deleteMessage"
      :confirm-text="deleteConfirmText"
      :reject-text="deleteRejectText"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EmailEditor } from 'vue-email-editor';
import EmailTemplateAPI from '../../../../../api/emailTemplates';
import EmptyState from '../../../../../components/widgets/EmptyState.vue';
import Spinner from 'shared/components/Spinner';

export default {
  name: 'EmailTemplate',
  components: {
    EmailEditor,
    EmptyState,
    Spinner,
  },
  data() {
    return {
      testHtml: `<!DOCTYPE HTML PUBLIC "-//W3C//DTD XHTML 1.0 Transitional //EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n<html xmlns="http://www.w3.org/1999/xhtml" xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office">\n<head>\n\x3C!--[if gte mso 9]>\n<xml>\n  <o:OfficeDocumentSettings>\n    <o:AllowPNG/>\n    <o:PixelsPerInch>96</o:PixelsPerInch>\n  </o:OfficeDocumentSettings>\n</xml>\n<![endif]-->\n  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">\n  <meta name="viewport" content="width=device-width, initial-scale=1.0">\n  <meta name="x-apple-disable-message-reformatting">\n  \x3C!--[if !mso]>\x3C!--><meta http-equiv="X-UA-Compatible" content="IE=edge">\x3C!--<![endif]-->\n  <title></title>\n  \n    <style type="text/css">\n      @media only screen and (min-width: 620px) {\n  .u-row {\n    width: 600px !important;\n  }\n  .u-row .u-col {\n    vertical-align: top;\n  }\n\n  .u-row .u-col-33p33 {\n    width: 199.98px !important;\n  }\n\n  .u-row .u-col-50 {\n    width: 300px !important;\n  }\n\n  .u-row .u-col-100 {\n    width: 600px !important;\n  }\n\n}\n\n@media (max-width: 620px) {\n  .u-row-container {\n    max-width: 100% !important;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .u-row .u-col {\n    min-width: 320px !important;\n    max-width: 100% !important;\n    display: block !important;\n  }\n  .u-row {\n    width: 100% !important;\n  }\n  .u-col {\n    width: 100% !important;\n  }\n  .u-col > div {\n    margin: 0 auto;\n  }\n}\nbody {\n  margin: 0;\n  padding: 0;\n}\n\ntable,\ntr,\ntd {\n  vertical-align: top;\n  border-collapse: collapse;\n}\n\np {\n  margin: 0;\n}\n\n.ie-container table,\n.mso-container table {\n  table-layout: fixed;\n}\n\n* {\n  line-height: inherit;\n}\n\na[x-apple-data-detectors='true'] {\n  color: inherit !important;\n  text-decoration: none !important;\n}\n\ntable, td { color: #000000; } #u_body a { color: #0000ee; text-decoration: underline; } @media (max-width: 480px) { #u_content_image_1 .v-src-width { width: auto !important; } #u_content_image_1 .v-src-max-width { max-width: 58% !important; } }\n    </style>\n  \n  \n\n\x3C!--[if !mso]>\x3C!--><link href="https://fonts.googleapis.com/css?family=Montserrat:400,700" rel="stylesheet" type="text/css">\x3C!--<![endif]-->\n\n</head>\n\n<body class="clean-body u_body" style="margin: 0;padding: 0;-webkit-text-size-adjust: 100%;background-color: #e8d4bb;color: #000000">\n  \x3C!--[if IE]><div class="ie-container"><![endif]-->\n  \x3C!--[if mso]><div class="mso-container"><![endif]-->\n  <table id="u_body" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;min-width: 320px;Margin: 0 auto;background-color: #e8d4bb;width:100%" cellpadding="0" cellspacing="0">\n  <tbody>\n  <tr style="vertical-align: top">\n    <td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top">\n    \x3C!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td align="center" style="background-color: #e8d4bb;"><![endif]-->\n    \n  \n  \n<div class="u-row-container" style="padding: 0px;background-color: transparent">\n  <div class="u-row" style="margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: transparent;">\n    <div style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;">\n      \x3C!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: transparent;"><![endif]-->\n      \n\x3C!--[if (mso)|(IE)]><td align="center" width="600" style="width: 600px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->\n<div class="u-col u-col-100" style="max-width: 320px;min-width: 600px;display: table-cell;vertical-align: top;">\n  <div style="height: 100%;width: 100% !important;">\n  \x3C!--[if (!mso)&(!IE)]>\x3C!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">\x3C!--<![endif]-->\n  \n<table style="font-family:'Montserrat',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">\n  <tbody>\n    <tr>\n      <td style="overflow-wrap:break-word;word-break:break-word;padding:5px;font-family:'Montserrat',sans-serif;" align="left">\n        \n  <table height="0px" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse: collapse;table-layout: fixed;border-spacing: 0;mso-table-lspace: 0pt;mso-table-rspace: 0pt;vertical-align: top;border-top: 0px solid #BBBBBB;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%">\n    <tbody>\n      <tr style="vertical-align: top">\n        <td style="word-break: break-word;border-collapse: collapse !important;vertical-align: top;font-size: 0px;line-height: 0px;mso-line-height-rule: exactly;-ms-text-size-adjust: 100%;-webkit-text-size-adjust: 100%">\n          <span>&#160;</span>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n\n      </td>\n    </tr>\n  </tbody>\n</table>\n\n  \x3C!--[if (!mso)&(!IE)]>\x3C!--></div>\x3C!--<![endif]-->\n  </div>\n</div>\n\x3C!--[if (mso)|(IE)]></td><![endif]-->\n      \x3C!--[if (mso)|(IE)]></tr></table></td></tr></table><![endif]-->\n    </div>\n  </div>\n  </div>\n  \n\n\n  \n  \n<div class="u-row-container" style="padding: 0px;background-color: transparent">\n  <div class="u-row" style="margin: 0 auto;min-width: 320px;max-width: 600px;overflow-wrap: break-word;word-wrap: break-word;word-break: break-word;background-color: #ffffff;">\n    <div style="border-collapse: collapse;display: table;width: 100%;height: 100%;background-color: transparent;">\n      \x3C!--[if (mso)|(IE)]><table width="100%" cellpadding="0" cellspacing="0" border="0"><tr><td style="padding: 0px;background-color: transparent;" align="center"><table cellpadding="0" cellspacing="0" border="0" style="width:600px;"><tr style="background-color: #ffffff;"><![endif]-->\n      \n\x3C!--[if (mso)|(IE)]><td align="center" width="200" style="width: 200px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->\n<div class="u-col u-col-33p33" style="max-width: 320px;min-width: 200px;display: table-cell;vertical-align: top;">\n  <div style="height: 100%;width: 100% !important;">\n  \x3C!--[if (!mso)&(!IE)]>\x3C!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">\x3C!--<![endif]-->\n  \n<table style="font-family:'Montserrat',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">\n  <tbody>\n    <tr>\n      <td style="overflow-wrap:break-word;word-break:break-word;padding:25px 10px 10px;font-family:'Montserrat',sans-serif;" align="left">\n        \n<div class="menu" style="text-align:center">\n\x3C!--[if (mso)|(IE)]><table role="presentation" border="0" cellpadding="0" cellspacing="0" align="center"><tr><![endif]-->\n\n  \x3C!--[if (mso)|(IE)]><td style="padding:5px 15px"><![endif]-->\n  \n  <span style="padding:5px 15px;display:inline-block;color:#444444;font-family:'Montserrat',sans-serif;font-size:14px;">\n    NEWS\n  </span>\n  \n  \x3C!--[if (mso)|(IE)]></td><![endif]-->\n  \n\n  \x3C!--[if (mso)|(IE)]><td style="padding:5px 15px"><![endif]-->\n  \n  <span style="padding:5px 15px;display:inline-block;color:#444444;font-family:'Montserrat',sans-serif;font-size:14px;">\n    SERVICE\n  </span>\n  \n  \x3C!--[if (mso)|(IE)]></td><![endif]-->\n  \n\n\x3C!--[if (mso)|(IE)]></tr></table><![endif]-->\n</div>\n\n      </td>\n    </tr>\n  </tbody>\n</table>\n\n  \x3C!--[if (!mso)&(!IE)]>\x3C!--></div>\x3C!--<![endif]-->\n  </div>\n</div>\n\x3C!--[if (mso)|(IE)]></td><![endif]-->\n\x3C!--[if (mso)|(IE)]><td align="center" width="200" style="width: 200px;padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;" valign="top"><![endif]-->\n<div class="u-col u-col-33p33" style="max-width: 320px;min-width: 200px;display: table-cell;vertical-align: top;">\n  <div style="height: 100%;width: 100% !important;">\n  \x3C!--[if (!mso)&(!IE)]>\x3C!--><div style="box-sizing: border-box; height: 100%; padding: 0px;border-top: 0px solid transparent;border-left: 0px solid transparent;border-right: 0px solid transparent;border-bottom: 0px solid transparent;">\x3C!--<![endif]-->\n  \n<table id="u_content_image_1" style="font-family:'Montserrat',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0">\n  <tbody>\n    <tr>\n      <td style="overflow-wrap:break-word;word-break:break-word;padding:20px 10px;font-family:'Montserrat',sans-serif;" align="left">\n        \n<table width="100%" cellpadding="0" cellspacing="0" border="0">\n  <tr>\n    <td style="padding-right: 0px;padding-left: 0px;" align="center">\n      \n      <img align="center" border="0" src="https://cdn.templates.unlayer.com/assets/1606906849237-logo.png" alt="Image" title="Image" style="outline: none;text-decoration: none;-ms-interpolation-mode: bicubic;clear: both;display: inline-block !important;border: none;height: auto;float: none;width: 77%;max-width: 138.6px;" width="138.6" class="v-src-width v-src-max-width"/>`,
      showDeleteConfirmationPopup: false,
      searchQuery: '',
      activeCategory: 'All',
      activeCategoryTab: 0,
      isFetchinigEmailTemplate: false,
      emailTemplates: [],
      selecteTemplateIdForDelete: null,
      isDeleteingTemplate: false,
      serverParams: '',
      categories: ['All'],
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
    }),
    // Delete Modal
    deleteConfirmText() {
      return `${this.$t('CAMPAIGN.DELETE.CONFIRM.YES')}`;
    },
    deleteRejectText() {
      return `${this.$t('CAMPAIGN.DELETE.CONFIRM.NO')}`;
    },
    deleteMessage() {
      return `${this.$t('CAMPAIGN.DELETE.CONFIRM.MESSAGE')}?`;
    },
  },
  created() {
    this.getCategories();
    this.getTemplates();
  },
  methods: {
    async getCategories() {
      await EmailTemplateAPI.getCategories().then(response => {
        this.categories = this.categories.concat(response.data);
      });
    },
    async getTemplates(dataParams = this.serverParams) {
      this.isFetchinigEmailTemplate = true;
      await EmailTemplateAPI.getTemplates(dataParams)
        .then(response => {
          let tempData = [];
          this.emailTemplates = tempData;
          if (response.data.length > 0) {
            response.data.map(data => {
              tempData.push({ ...data, templateBody: JSON.parse(data.body) });
            });           
          } else {
            tempData.push({
              ...response.data,
              templateBody: JSON.parse(response.data.body),
            });
          }
          this.emailTemplates = tempData;
        })
        .catch(error => {})
        .finally(() => {
          this.isFetchinigEmailTemplate = false;
        });
    },
    openDeletePopup(index) {
      this.selecteTemplateIdForDelete = index;
      this.showDeleteConfirmationPopup = true;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    async confirmDeletion() {
      this.isDeleteingTemplate = true;
      await EmailTemplateAPI.deleteTemplate(this.selecteTemplateIdForDelete)
        .then(response => {
          this.closeDeletePopup();
          this.getTemplates();
        })
        .catch(error => {})
        .finally(() => {
          this.isDeleteingTemplate = false;
        });
    },
    onInputSearch(event) {
      const newQuery = event.target.value;
      this.searchQuery = newQuery;
    },
    onSearchSubmit() {
      let dataToSend = '';
      if (this.searchQuery) {
        dataToSend = `name=${this.searchQuery}`;
      }
      this.getTemplates(dataToSend);
    },
    onTabChange(selectedTabIndex) {
      let dataToSend = '';
      this.activeCategoryTab = selectedTabIndex;
      this.activeCategory = this.categories[selectedTabIndex];
      if (this.activeCategory !== 'All') {
        dataToSend = `category=${this.activeCategory}`;
      }
      this.getTemplates(dataToSend);
    },
  },
};
</script>


<style scoped lang="scss">
.search-wrap {
  width: 400px;
  display: flex;
  align-items: center;
  position: relative;
  margin-right: var(--space-small);

  .search-icon {
    position: absolute;
    top: 1px;
    left: var(--space-one);
    height: 3.8rem;
    line-height: 3.6rem;
    font-size: var(--font-size-medium);
    color: var(--b-700);
  }

  .contact-search {
    margin: 0;
    height: 3.8rem;
    width: 100%;
    padding-left: var(--space-large);
    padding-right: 6rem;
    border-color: var(--s-100);
  }

  .button {
    margin-left: var(--space-small);
    height: 3.2rem;
    right: var(--space-smaller);
    position: absolute;
    padding: 0 var(--space-small);
    transition: transform 100ms linear;
    opacity: 0;
    transform: translateX(-1px);
    visibility: hidden;
  }

  .button.show {
    opacity: 1;
    transform: translateX(0);
    visibility: visible;
  }
}
</style>